import * as React from "react";
import Header from "./Header";
import UserAdmin from "../admin/UserAdmin";

export default function LayoutUserAdmin() {
  return (
    <>
      <Header />
      <UserAdmin />
    </>
  );
}
